
import { useState } from 'react';
import { Button } from './ui/button';
import { MessageSquare } from 'lucide-react';
import { FeedbackDialog } from './FeedbackDialog';

export function FloatingFeedbackButton() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Button
        className="fixed bottom-4 right-4 h-14 w-14 rounded-full shadow-lg"
        onClick={() => setIsDialogOpen(true)}
      >
        <MessageSquare size={24} />
      </Button>
      <FeedbackDialog isOpen={isDialogOpen} onOpenChange={setIsDialogOpen} />
    </>
  );
}
